import request from '../util/request'
import { encodeVisitLogParams } from '@ost/static'
const baseURL = '/base-api'
// 上传签名请求
export function sendSignImg (data, headers) {
  return request.post('/vat/taxGrantInfo/justSaveSignPic', data, 'params')
}
// 上传签名请求
export function austriaSendSignImg (data, headers) {
  return request.post('/vat/taxGrantInfo/saveSignPicForDeclare', data, 'params')
}
// 奥地利上传签名请求
export function austriaZeroDeclare (data, headers) {
  return request.post('/vat/taxGrantInfo/saveSignPicForZeroDeclare', data, 'params')
}
// 上传签名请求
export function getCompanySign (data, headers) {
  return request.post('/vat/taxGrantInfo/saveSignPicForMcIdentifInfo', data, 'params')
}

// 上传协议签名请求
export function saveSignPicForDeclare (data) {
  let headers = {}
  let formData = new FormData()
  for (const key in data) {
    formData.append(key, data[key])
    headers = {
      processData: 'false',
      contentType: 'false'
    }
  }
  data = formData
  return request.service({
    url: `/business/merchantServiceData/saveSignPicForDeclare`,
    method: 'post',
    data,
    headers,
    baseURL
  })
}

// 注册、登录页面的访问记录
export function addRegVisitLog (data) {
  // 校验channelCode为空、'undefined'字符串的情况
  if (data && (!data.channelCode || data.channelCode === 'undefined')) {
    console.warn('channelCode', data.channelCode)
    data.channelCode = ''
  }
  return request.post('/system/api/visitor/record', encodeVisitLogParams(data), null)
}



// WEBPACK FOOTER //
// ./src/api/sign.js